{
  "pointsBalance": {
    "noPointsMainText": "Avios is our loyalty currency. Collect or buy Avios and enter a world of countless benefits.",
    "noPointsFooterText": "Avios expire if you have no transactions at least once every 18 months.",
    "collectAvios": "How to collect avios"
  }
}
